import { useEffect, useMemo } from 'react';
import { useService } from 'hooks/useService';

interface UseLienLawProps {
    country_id: number;
}

interface LienLaw {
    id: string;
    state_id: string;
    link: string;
    created_at: string;
    modified: string;
    state_name: string;
    iso_numeric: string;
    country_id: string;
    country_name: string;
}

interface ServiceResponse {
    data: {
        results: LienLaw[];
    };
    loading: boolean;
}

interface LetterHeading {
    startIndex: number;
    endIndex: number;
    startLabel: string;
    endLabel: string;
}

const getBreakPoint = (length: number) => {
    return Math.ceil(length / 4);
};

export const useLienLaws = ({ country_id }: UseLienLawProps) => {
    const [serviceResponse, fireLoadLienLaws] = useService({
        url: 'lien-laws',
        params: {
            sort_column: 'state_name',
            sort_direction: 'asc',
            country_id: country_id,
        },
    });

    const {
        data: { results: lienLaws = [] },
        loading,
        //@ts-ignore
    } = serviceResponse as ServiceResponse;

    const headings: LetterHeading[] = useMemo(() => {
        const letterHeadings = [];
        const totalStates = lienLaws.length;
        const itemsToShow = getBreakPoint(totalStates);

        for (let i = 0; i < totalStates; i += itemsToShow) {
            const endIndex = Math.min(i + itemsToShow - 1, totalStates - 1);

            const startLabel = lienLaws[i].state_name[0].toUpperCase();
            let endLabel = lienLaws[endIndex].state_name[0].toUpperCase();
            const hasNextColumn = i + itemsToShow < totalStates;
            if (!hasNextColumn) {
                endLabel = 'Z';
            }
            letterHeadings.push({
                startIndex: i,
                endIndex,
                startLabel,
                endLabel,
            });
        }

        return letterHeadings;
    }, [lienLaws]);

    useEffect(() => {
        fireLoadLienLaws();
    }, [country_id]);

    return {
        lienLaws,
        headings,
        loading,
    };
};
